/**
 * @desc 列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.BaseCountryTreeResponseDto>>;
export function request(
  body: defs.basics.BaseCountryRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/baseCountry/list/tree`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
